export const formatDateDDMMYYYY = (date) => {
  if (!date) return '';
  const parsed = new Date(date);
  const day = String(parsed.getDate()).padStart(2, '0');
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const year = parsed.getFullYear();
  return `${day}-${month}-${year}`;
};

export const parseNumericOrZero = (value) => {
  const numeric = parseFloat(value);
  return Number.isNaN(numeric) ? 0 : numeric;
};
